import React, { useState, useRef } from 'react';
import { compose } from 'ramda';
import { Item, Button, Heading, Content, ChevronWrapper, RichText } from './StyledAccordionItem';
import useAccordion from '_utils/hooks/useAccordion';
import { withEditMode } from '_containers/BaseComponent';
import { Chevron } from '_utils/icons';
import { getRandomId } from '_utils/data/';
import { AccordionItemData } from '.';

type AccordionItemProps = {
  item: AccordionItemData;
  headingLevel?: number | string;
  editMode?: boolean;
};

const AccordionItem: React.FC<AccordionItemProps> = ({ item, headingLevel = 3, editMode }) => {
  const { title, content, showExpanded } = item;
  const contentRef = useRef(null);
  const openAccordionItem = !!showExpanded?.data?.value || editMode;
  const { expanded, setExpanded, contentStyle } = useAccordion(contentRef, openAccordionItem);
  const [hoverActive, setHoverActive] = useState(false);
  const [clickActive, setClickActive] = useState(false);
  const idRef = useRef(getRandomId());
  const id = idRef.current;

  const buttonProps = editMode
    ? {
      as: 'div'
    }
    : {
      'aria-expanded': expanded,
      'aria-controls': `content-${id}`,
      onClick: () => setExpanded(!expanded),
      onMouseEnter: () => setHoverActive(true),
      onMouseLeave: () => setHoverActive(false)
    };
  return (
    <Item
      className={`${editMode ? 'edit-mode' : ''} ${expanded ? 'expanded' : ''} ${hoverActive ? 'hover-active' : ''} ${clickActive ? 'click-active' : ''}
`}
      onClick={() => setClickActive(true)}
      onBlur={() => setClickActive(false)}
    >
      <Button {...buttonProps}>
        <Heading
          tag={typeof headingLevel === 'number' ? `h${headingLevel}` : headingLevel}
          field={title.data}
        />
        <ChevronWrapper>
          <Chevron ariaHidden={true} />
        </ChevronWrapper>
      </Button>
      <Content style={contentStyle} ref={contentRef} aria-hidden={!expanded} id={`content-${id}`} $isExpanding={expanded}>
        <RichText field={content.data} />
      </Content>
    </Item>
  );
};

export default compose(withEditMode)(AccordionItem);
